import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../components/home/Home"));
const About = lazy(() => import("../pages/about/About"));
const Service = lazy(() => import("../pages/service/Service"));
const Contact = lazy(() => import("../pages/contact/Contact"));
const Login = lazy(() => import("../pages/login/Login"));
const Register = lazy(() => import("../pages/register/Register"));

const fallbackComponent = <div>Loading...</div>;

const routes = [
  { path: "/", component: Home },
  { path: "/about", component: About },
  { path: "/service", component: Service },
  { path: "/contact", component: Contact },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
];

function AllRoutes() {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            <Suspense fallback={fallbackComponent}>
              <route.component />
            </Suspense>
          }
        />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AllRoutes;
